import HomeView from './views/home'
import RegistrationView from './views/registration'
import PasswordResetView from './views/password-reset'

import ProjectsView from './views/projects/projects'
import ProjectsTableView from './views/projects/table'
import ProjectsNewView from './views/projects/new'
import ProjectsDetailView from './views/projects/detail'
import ProjectsEditView from './views/projects/edit.vue'

import ProjectTypesView from './views/projects/type/list.vue'
import ProjectTypeNewView from './views/projects/type/new.vue'
import ProjectTypeEditView from './views/projects/type/edit.vue'

import TemplatesView from './views/projects/templates/list.vue'
import TemplatesCreateFrom from './views/projects/templates/create-from'

import TasksView from './views/tasks/tasks'
import TasksTableView from './views/tasks/table'
import TaskDetailView from './views/tasks/detail'
import TaskEditView from './views/tasks/edit'
import TaskNewView from './views/tasks/new'

import TaskTypesView from './views/tasks/type/list.vue'
import TaskTypeNewView from './views/tasks/type/new.vue'
import TaskTypeEditView from './views/tasks/type/edit.vue'

import ResourcesView from './views/resource/resources'
import ResourcesListView from './views/resource/list'
import ResourcesEditView from './views/resource/edit'
import ResourcesNewView from './views/resource/new'

import ResourceTypesView from './views/resource/type/list.vue'
import ResourceTypeNewView from './views/resource/type/new.vue'
import ResourceTypeEditView from './views/resource/type/edit.vue'

import PropertyTypeView from './views/property-type/property-types'
import PropertyTypeListView from './views/property-type/list'
import PropertyTypeEditView from './views/property-type/edit'
import PropertyTypeNewView from './views/property-type/new'

import UserProfileEditView from './views/users/profile/edit'

import UsersAdministrationView from './views/users/administration'
import UsersAdministrationListView from './views/users/administration/table'
import UsersAdministrationDetailView from './views/users/administration/detail'
import UsersAdministrationNewView from './views/users/administration/new'

import SettingsView from './views/settings'
import SettingsFlexibeeView from './views/settings/flexibee'
import SettingsDevView from './views/settings/dev'
import SettingsGroups from './views/settings/acl/groups'
import SettingsCompanyTemplateView from './views/settings/company-template/table'
import SettingsCompanyTemplateDetailView from './views/settings/company-template/detail'
import SettingsSamba from './views/settings/samba'
import SettingsSambaDetail from './views/settings/samba-detail'

import SettingsStatesListView from './views/settings/entity-states/list'
import SettingsStatesDetailView from './views/settings/entity-states/detail'

import CalendarView from './views/calendar/calendar'

import DashboardView from './views/dashboard'
import FirstRunView from './views/first-run'

import AddonsSettings from './views/addons'

export default [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: { onlyNotLogged: false },
    },
    {
        path: '/registration',
        name: 'registration',
        component: RegistrationView,
        meta: { onlyNotLogged: false },
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordResetView,
        meta: { onlyNotLogged: false },
    },
    {
        path: '/projects',
        name: 'projects',
        component: ProjectsView,
        redirect: { name: 'projectsList', params: { status: '$active' } },
        children: [
            {
                path: 'list/:status',
                name: 'projectsList',
                component: ProjectsTableView,
            },
            {
                path: 'new',
                name: 'projectsNew',
                component: ProjectsNewView,
            },
            {
                path: 'detail/:id',
                name: 'projectsDetail',
                component: ProjectsDetailView,
            },
            {
                path: 'edit/:id',
                name: 'projectsEdit',
                component: ProjectsEditView,
            },
            {
                path: 'types',
                name: 'projectTypesList',
                component: ProjectTypesView,
            },
            {
                path: 'new-type',
                name: 'projectTypeNew',
                component: ProjectTypeNewView,
            },
            {
                path: 'edit-type/:id',
                name: 'projectTypeEdit',
                component: ProjectTypeEditView,
            },
            {
                path: 'templates',
                name: 'templates',
                component: TemplatesView,
            },
            {
                path: 'create-from-template/:id',
                name: 'createProjectFromTemplate',
                component: TemplatesCreateFrom,
            },
        ],
    },
    {
        path: '/tasks',
        name: 'tasks',
        component: TasksView,
        redirect: { name: 'tasksList', params: { status: '$active' } },
        children: [
            {
                path: 'list/:status',
                name: 'tasksList',
                component: TasksTableView,
            },
            {
                path: 'detail/:id',
                name: 'tasksDetail',
                component: TaskDetailView,
            },
            {
                path: 'new',
                name: 'tasksNew',
                component: TaskNewView,
            },
            {
                path: 'types',
                name: 'taskTypesList',
                component: TaskTypesView,
            },
            {
                path: 'new-type',
                name: 'taskTypeNew',
                component: TaskTypeNewView,
            },
            {
                path: 'edit-type/:id',
                name: 'taskTypeEdit',
                component: TaskTypeEditView,
            },
        ],
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: CalendarView,
    },
    {
        path: '/resources',
        name: 'resources',
        component: ResourcesView,
        redirect: { name: 'resourcesList', params: { status: '$active' } },
        children: [
            {
                path: 'list/:status',
                name: 'resourcesList',
                component: ResourcesListView,
            },
            {
                path: 'edit/:id',
                name: 'resourcesEdit',
                component: ResourcesEditView,
            },
            {
                path: 'new',
                name: 'resourcesNew',
                component: ResourcesNewView,
            },
            {
                path: 'types',
                name: 'resourceTypesList',
                component: ResourceTypesView,
            },
            {
                path: 'new-type',
                name: 'resourceTypeNew',
                component: ResourceTypeNewView,
            },
            // {
            //     path: 'detail-type/:id',
            //     name: 'resourceTypeDetail',
            //     component: ResourceTypeDetailView,
            // },
            {
                path: 'edit-type/:id',
                name: 'resourceTypeEdit',
                component: ResourceTypeEditView,
            },
        ],
    },
    {
        path: '/property-type',
        name: 'propertyTypes',
        component: PropertyTypeView,
        redirect: { name: 'propertyTypeList' },
        children: [
            {
                path: 'list',
                name: 'propertyTypeList',
                component: PropertyTypeListView,
            },
            {
                path: 'new',
                name: 'propertyTypeNew',
                component: PropertyTypeNewView,
            },
            {
                path: 'edit/:id',
                name: 'propertyTypeEdit',
                component: PropertyTypeEditView,
            },
        ],
    },
    {
        path: '/profile/edit',
        name: 'profileEdit',
        component: UserProfileEditView,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardView,
        meta: { onlyNotLogged: false },
    },
    {
        path: '/firstrun',
        name: 'firstrun',
        component: FirstRunView,
        meta: { onlyNotLogged: false },
    },
    {
        path: '/settings',
        name: 'settings',
        component: SettingsView,
        redirect: { name: 'settingsFlexibee' },
        children: [
            {
                path: 'flexibee',
                name: 'settingsFlexibee',
                component: SettingsFlexibeeView,
            },
            {
                path: 'dev',
                name: 'settingsDev',
                component: SettingsDevView,
            },
            {
                path: 'entity-states-list',
                name: 'settingsStatesList',
                component: SettingsStatesListView,
            },
            {
                path: 'entity-states-detail/:id',
                name: 'settingsStatesDetail',
                component: SettingsStatesDetailView,
            },
            {
                path: 'groups',
                name: 'settingsGroups',
                component: SettingsGroups,
            },
            {
                path: 'company-templates',
                name: 'settingsCompanyTemplateList',
                component: SettingsCompanyTemplateView,
            },
            {
                path: 'company-templates-detail/:id',
                name: 'settingsCompanyTemplateDetail',
                component: SettingsCompanyTemplateDetailView,
            },
            {
                path: 'samba',
                name: 'settingsSamba',
                component: SettingsSamba,
            },
            {
                path: 'samba/:id',
                name: 'settingsSambaFolders',
                component: SettingsSambaDetail,
            },
            {
                path: 'addons/:addonId/:instanceId',
                name: 'addonsSettings',
                component: AddonsSettings,
            },
        ],
    },
    {
        path: '/users',
        name: 'users',
        component: UsersAdministrationView,
        redirect: { name: 'usersList' },
        children: [
            {
                path: 'list',
                name: 'usersList',
                component: UsersAdministrationListView,
            },
            {
                path: 'detail/:id',
                name: 'usersDetail',
                component: UsersAdministrationDetailView,
            },
            {
                path: 'new',
                name: 'usersNew',
                component: UsersAdministrationNewView,
            },
        ],
    },
]
